function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#288b94;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "logoListaRepor");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "q890JA.tif"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M27.22,7.54l.22,3.09h-4.8V51.34H54.69c0-1.23,0-2.45,0-3.67,0-.55.11-.81.7-.92a22.72,22.72,0,0,0,2.37-.68,4.88,4.88,0,0,1,.06.52c0,1.77,0,3.54,0,5.3a2.38,2.38,0,0,1-2.61,2.6h-33a2.36,2.36,0,0,1-2.63-2.64V10.14a2.35,2.35,0,0,1,2.59-2.6Z",
  transform: "translate(-19.54 -2.07)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M61.83,40.89c1,1,1.91,1.92,2.89,2.85.12.11.41,0,.62.06.46.09,1.08,0,1.37.32,3.28,3.2,6.51,6.45,9.74,9.7a1.15,1.15,0,0,1,0,1.77c-.65.69-1.31,1.35-2,2a1.15,1.15,0,0,1-1.83,0c-3.25-3.22-6.49-6.47-9.72-9.71a1.19,1.19,0,0,1-.17-1.63L59.6,43.08a11.95,11.95,0,1,1,0-19A12.17,12.17,0,0,1,61.83,40.89Zm-9.47,2.38a9.75,9.75,0,1,0-9.75-9.77A9.76,9.76,0,0,0,52.36,43.27Z",
  transform: "translate(-19.54 -2.07)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M34.62,6c.43-2.41,1.78-3.79,3.8-3.9,2.2-.12,3.49,1,4.37,4h4.13c1.09,0,1.45.35,1.46,1.43,0,.53,0,1.07,0,1.6a3,3,0,0,1-2.88,2.92c-4.55,0-9.1,0-13.65,0a2.85,2.85,0,0,1-2.77-2.37A10.51,10.51,0,0,1,29,7.05c.05-.69.59-1,1.27-1,1.42,0,2.83,0,4.25,0C34.52,6.06,34.55,6,34.62,6ZM38.74,4.3a1.78,1.78,0,1,0-.1,3.55,1.78,1.78,0,0,0,.1-3.55Z",
  transform: "translate(-19.54 -2.07)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M57.79,21a24.62,24.62,0,0,0-2.49-.71c-.52-.11-.62-.33-.62-.81,0-2.62,0-5.24,0-7.86v-1H49.9l.21-3.09h3c.78,0,1.55,0,2.33,0a2.24,2.24,0,0,1,2.33,2.1C57.83,13.41,57.79,17.17,57.79,21Z",
  transform: "translate(-19.54 -2.07)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M35.27,19.66v-2h16v2Z",
  transform: "translate(-19.54 -2.07)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M28.72,17.51c1-1,1.83-1.85,2.67-2.72.46-.48,1-.7,1.53-.19s.4,1-.16,1.53q-1.54,1.56-3.12,3.11a1.08,1.08,0,0,1-1.74,0c-.54-.52-1.06-1-1.58-1.59a.89.89,0,0,1-.05-1.35.9.9,0,0,1,1.41,0C28,16.7,28.32,17.07,28.72,17.51Z",
  transform: "translate(-19.54 -2.07)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M28.69,42.05l2.68-2.75c.47-.48,1-.71,1.54-.22s.41,1-.2,1.59q-1.52,1.53-3.06,3.06a1.08,1.08,0,0,1-1.79,0q-.78-.75-1.53-1.53a.91.91,0,0,1,0-1.41.88.88,0,0,1,1.35.06C28,41.18,28.28,41.57,28.69,42.05Z",
  transform: "translate(-19.54 -2.07)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M28.77,25.74c.93-1,1.74-1.87,2.58-2.73.59-.61,1.16-.68,1.59-.24s.37,1-.26,1.59q-1.53,1.52-3.11,3a1.09,1.09,0,0,1-1.79-.05L26.37,25.9a.93.93,0,0,1-.1-1.42.92.92,0,0,1,1.42.05C28,24.86,28.32,25.24,28.77,25.74Z",
  transform: "translate(-19.54 -2.07)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M28.8,33.77c.93-.94,1.8-1.8,2.64-2.68a1,1,0,0,1,1.48-.18.92.92,0,0,1,0,1.42c-1.11,1.13-2.22,2.24-3.35,3.35a1,1,0,0,1-1.5,0c-.59-.54-1.16-1.11-1.71-1.69-.36-.38-.53-.86-.09-1.27a1,1,0,0,1,1.38,0Z",
  transform: "translate(-19.54 -2.07)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M43.86,44.14H35.27v-2c1.31,0,2.59.09,3.86,0,1.71-.14,3.21.07,4.24,1.63A4.26,4.26,0,0,0,43.86,44.14Z",
  transform: "translate(-19.54 -2.07)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M41.14,25.79c-.36.64-.65,1.21-1,1.74a.72.72,0,0,1-.5.3c-1.43,0-2.87,0-4.37,0V25.79Z",
  transform: "translate(-19.54 -2.07)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M35.28,36V34h3.47L39,36Z",
  transform: "translate(-19.54 -2.07)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M59.5,36.6A9.87,9.87,0,0,0,49.41,26.43c1.56-1.17,5.36-1,7.69.84A7.81,7.81,0,0,1,59.5,36.6Z",
  transform: "translate(-19.54 -2.07)"
}));

var SvgLogoListaRepor = function SvgLogoListaRepor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 57.34 55.97",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoListaRepor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoListaRepor.5f8662e6.svg";
export { ForwardRef as ReactComponent };